import { NavLink } from 'react-router-dom';
import type { UserRole } from '../../hooks/useAuth';
import { LayoutDashboard, FileText, MessageSquare, Bell, User, Truck, Home, Wrench } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface NavItem {
  to:    string;
  icon:  LucideIcon;
  label: string;
}

const NAV_ITEMS: Record<UserRole, NavItem[]> = {
  broker: [
    { to: '/dashboard',       icon: LayoutDashboard, label: 'Tablero'    },
    { to: '/orders',          icon: FileText,        label: 'Mis Órdenes' },
    { to: '/messages',        icon: MessageSquare,   label: 'Mensajería'  },
    { to: '/notifications',   icon: Bell,            label: 'Alertas'     },
    { to: '/profile',         icon: User,            label: 'Perfil'      },
  ],
  carrier: [
    { to: '/dashboard',       icon: LayoutDashboard, label: 'Tablero'     },
    { to: '/trucks',          icon: Truck,           label: 'Mis Camiones' },
    { to: '/orders',          icon: FileText,        label: 'Mis Órdenes'  },
    { to: '/messages',        icon: MessageSquare,   label: 'Mensajería'   },
    { to: '/profile',         icon: User,            label: 'Perfil'       },
  ],
  service_provider: [
    { to: '/dashboard',       icon: Home,            label: 'Inicio'       },
    { to: '/services',        icon: Wrench,          label: 'Mis Servicios' },
    { to: '/orders',          icon: FileText,        label: 'Mis Órdenes'   },
    { to: '/messages',        icon: MessageSquare,   label: 'Mensajería'    },
    { to: '/profile',         icon: User,            label: 'Perfil'        },
  ],
};

// Color activo por rol — usa tokens del design system
const ACTIVE_COLOR: Record<UserRole, string> = {
  broker:           'text-broker',
  carrier:          'text-carrier',
  service_provider: 'text-provider',
};

interface BottomNavProps {
  role: UserRole;
}

export function BottomNav({ role }: BottomNavProps) {
  const items      = NAV_ITEMS[role];
  const activeColor = ACTIVE_COLOR[role];

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border safe-area-pb">
      <div className="flex items-stretch h-16 max-w-lg mx-auto">
        {items.map(item => {
          const ItemIcon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/dashboard'}
              className={({ isActive }) => [
                'flex-1 flex flex-col items-center justify-center gap-0.5 pt-2 pb-1',
                'text-[9px] font-medium transition-colors duration-150',
                isActive ? activeColor : 'text-gray-400 dark:text-dark-text-muted',
              ].join(' ')}
            >
              <ItemIcon className="w-5 h-5" strokeWidth={2} />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
